import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import {
  CreateRequisitionOwnerRequest,
  HttpResponse,
  RequisitionOwner,
} from "@/types";

export function useCreateRequisitionOwner() {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({
      createRequisitionOwnerRequest,
    }: {
      createRequisitionOwnerRequest: CreateRequisitionOwnerRequest;
    }) => {
      // TODO STF-176: Cleanup paths for delete and create requisition owners. Create and Delete should not be so different.
      const path = "requisition-owners";
      const res = await guacHttpClient.post<
        RequisitionOwner,
        HttpResponse<RequisitionOwner>,
        CreateRequisitionOwnerRequest
      >(path, createRequisitionOwnerRequest);

      return res.data;
    },
    onSuccess: () => {
      // Invalidate queries that have job intake
      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });
    },
  });

  return mutation;
}
